// front/src/utils/formatters.js
export const formatCPF = (value) => {
  const numbers = (value || '').replace(/\D/g, '').slice(0, 11);
  return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatCNPJ = (value) => {
  const numbers = (value || '').replace(/\D/g, '').slice(0, 14);
  return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

export const formatPhone = (value) => {
  const numbers = (value || '').replace(/\D/g, '').slice(0, 11);
  if (numbers.length <= 10) {
    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};

export const formatCEP = (value) => {
  const numbers = (value || '').replace(/\D/g, '').slice(0, 8);
  return numbers.replace(/(\d{5})(\d{3})/, '$1-$2');
};

export const formatDate = (dateValue) => {
  if (!dateValue) return '';
  const value = String(dateValue).trim();
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T00:00:00`)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR');
};